import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=379f1de2&"
import script from "./Greetings.vue?vue&type=script&lang=js&"
export * from "./Greetings.vue?vue&type=script&lang=js&"
import style0 from "./Greetings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports